import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext.js";
import "./styles/AdminArticles.css";

const AdminArticles = () => {
  const { token } = useContext(AuthContext);
  const [articles, setArticles] = useState([]);
  const [error, setError] = useState(null);
  const [selectedRole, setSelectedRole] = useState("All");
  const roles = ["All", "admin", "journalist", "reporter"];

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        let url = "/api/admin/articles";
        if (selectedRole !== "All") {
          url = `/api/admin/articles?role=${selectedRole}`;
        }
        const resp = await fetch(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!resp.ok) throw new Error(`Failed to fetch articles: ${resp.status}`);
        const data = await resp.json();
        setArticles(data);
      } catch (err) {
        console.error("Error loading articles:", err);
        setError(err.message);
      }
    };
    fetchArticles();
  }, [token, selectedRole]);

  return (
    <div className="admin-layout">
      <div className="admin-layout-inner">
        <div className="admin-page-header">
          <h1>All Articles</h1>
          <p>View and manage articles across all roles</p>
        </div>

        {error && <div className="admin-alert admin-alert-error">{error}</div>}

        <div className="admin-toolbar">
          <div className="admin-toolbar-left">
            <span className="admin-filter-label">Author Role</span>
            <select
              className="admin-select"
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
            >
              {roles.map((role) => (
                <option key={role} value={role}>
                  {role === "All" ? "All Roles" : role.charAt(0).toUpperCase() + role.slice(1)}
                </option>
              ))}
            </select>
          </div>
          <div style={{ fontSize: "0.8125rem", color: "var(--admin-text-muted)" }}>
            {articles.length} article{articles.length !== 1 ? "s" : ""}
          </div>
        </div>

        {articles.length === 0 ? (
          <div className="admin-card">
            <div className="admin-empty">No articles found for this filter.</div>
          </div>
        ) : (
          <div className="admin-card">
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Title</th>
                    <th>Excerpt</th>
                    <th>Author</th>
                    <th>Created</th>
                    <th>Published</th>
                  </tr>
                </thead>
                <tbody>
                  {articles.map((a) => (
                    <tr key={a.id}>
                      <td>{a.id}</td>
                      <td style={{ fontWeight: 500, maxWidth: "250px" }}>{a.title}</td>
                      <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.excerpt}</td>
                      <td>{a.author_name || a.author_id}</td>
                      <td>{new Date(a.created_at).toLocaleDateString()}</td>
                      <td>
                        <span className={`admin-badge admin-badge-${a.is_published ? "yes" : "no"}`}>
                          {a.is_published ? "Published" : "Draft"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminArticles;
